import React from "react";
import { Link } from "react-router-dom";
import { useBilling } from "@/context/BillingContext";
import { Sparkles, X, AlertTriangle } from "lucide-react";

export default function TrialBanner() {
  const { status } = useBilling();
  const [dismissed, setDismissed] = React.useState(false);

  if (!status || dismissed) return null;

  // Show for trial (days remaining) and free (upgrade)
  const isTrial = status.plan === "trial" && status.effective_plan === "trial";
  const isExpiredFree = status.effective_plan === "free";

  if (!isTrial && !isExpiredFree) return null;

  return (
    <div className="w-full bg-amber text-[#0B0D12] px-6 py-2 flex items-center gap-3 relative z-30" data-testid="trial-banner">
      {isTrial ? (
        <>
          <Sparkles className="w-4 h-4 shrink-0" />
          <div className="text-xs font-condensed uppercase tracking-widest flex-1">
            <span className="font-bold">{status.trial_days_left} day{status.trial_days_left !== 1 ? "s" : ""} left</span> on your Pro Coach trial.
            Full access to unlimited AI, plays, and film.
          </div>
        </>
      ) : (
        <>
          <AlertTriangle className="w-4 h-4 shrink-0" />
          <div className="text-xs font-condensed uppercase tracking-widest flex-1">
            Free plan — Limited to {status.free_limits?.ai_messages_per_month || 5} AI messages / month, {status.free_limits?.plays || 10} plays, {status.free_limits?.film_clips || 10} film clips.
          </div>
        </>
      )}
      <Link
        to="/pricing"
        data-testid="banner-upgrade-link"
        className="bg-[#0B0D12] text-amber px-4 py-1.5 text-[10px] font-condensed uppercase tracking-[0.28em] hover:bg-black transition-colors"
      >
        Upgrade →
      </Link>
      <button onClick={() => setDismissed(true)} data-testid="banner-dismiss" className="hover:bg-black/10 p-1 -mr-1 transition-colors">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
